import React, { useState } from "react";
import { Row, Col, Spin, Form, Card, Input } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import { rightAction } from "../../../../redux/actions";
import {
  labelConfig,
  staticConfig,
  apiConfig,
} from "../../treasuryContractBooking.config";
import { BOM } from "../../../../services/definedMethod";

const LOCALE = "en";
const DATE_FORMAT_LOCALE = "dd MMMM yyyy";

const Tip = ({ text, tip }) => (
  <span>
    {text}
    <Tooltip title={tip}>
      <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
    </Tooltip>
  </span>
);

const CancelTrade = (props) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const tradeId = location.state;
  const { userData } = props;
  const { session } = userData || {};

  const onFinish = (values) => {
    if (!tradeId) {
      BOM.AlertMsg(
        cnt.DANGER,
        "Trade ID is missing. Please go back and try again.",
      );
      return;
    }

    const body = {
      session,
      method: "POST",
      locale: LOCALE,
      dateFormat: DATE_FORMAT_LOCALE,
      cancellationReason: values.cancellationReason,
    };

    const url = `${apiConfig.GetTrades}/trades/${tradeId}/cancel`;

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err) => {
      if (err) {
        BOM.AlertMsg(
          cnt.DANGER,
          err?.errors?.[0]?.defaultUserMessage ||
            err?.defaultUserMessage ||
            "Failed to cancel trade.",
        );
        setIsLoading(false);
        return;
      }

      BOM.AlertMsg(cnt.SUCCESS, "Trade cancelled successfully.");
      setIsLoading(false);
      navigate(-2);
    });
  };

  return (
    <MainLayout pageItems={staticConfig.manageTrade}>
      <TopContent pageTitle={labelConfig.trade} />

      <Spin spinning={isLoading} size="large">
        <div style={{ padding: "24px" }}>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            <h3 style={{ marginBottom: 24, fontWeight: 600 }}>Cancel Trade</h3>

            <Form layout="vertical" form={form} onFinish={onFinish}>
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <Tip
                        text="Cancellation Reason"
                        tip="Provide a clear reason for cancelling this trade."
                      />
                    }
                    name="cancellationReason"
                    rules={[
                      {
                        required: true,
                        message: "Cancellation reason is required",
                      },
                      {
                        min: 5,
                        message: "Please provide a more descriptive reason",
                      },
                    ]}
                  >
                    <Input.TextArea
                      rows={4}
                      placeholder="e.g. Client request — trade no longer required."
                      style={{
                        resize: "none",
                        borderRadius: 8,
                        fontSize: 14,
                        padding: "10px 12px",
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div
                style={{ borderTop: "1px solid #EAECF0", margin: "8px 0 20px" }}
              />

              <Row justify="end">
                <Col>
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      color: "#344054",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                      marginRight: 12,
                    }}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    onClick={() => form.submit()}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #B42318",
                      background: "#B42318",
                      color: "#fff",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                    }}
                  >
                    Cancel Trade
                  </button>
                </Col>
              </Row>

              <button type="submit" hidden />
            </Form>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  rightBtn: state.RightSideBtn,
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps, { rightAction })(CancelTrade);
